import { GET_WRITING_IMPLEMENT_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_WRITING_IMPLEMENT_RECIPES_SUCCESS: {
      const writingImplementRecipes = action.payload;

      if (!writingImplementRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
